import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OtpVerificationService {
  private otpVerifiedSubject = new Subject<{
    field: 'email' | 'phone';
    value: string;
    verified: boolean;
  }>();
  otpVerified$ = this.otpVerifiedSubject.asObservable();

  public emitVerification(payload: { field: 'email' | 'phone'; value: string; verified: boolean }) {
    this.otpVerifiedSubject.next(payload);
  }
}
